import { useRouter } from 'next/router';
import { useState } from 'react';
import DashboardPage from '../../../components/Dashboard/DashboardPage';
import Inbox from '../../../components/Dashboard/Inbox';
import withApollo from '../../../lib/withApollo';

const InboxPage = () => {
  const router = useRouter();

  const [unreadCountOffset, setUnreadCountOffset] = useState(0);

  const increaseUnreadCountOffset = () => {
    setUnreadCountOffset(unreadCountOffset + 1);
  };

  const { open } = router.query;
  return (
    <DashboardPage
      unreadCountOffset={unreadCountOffset}
      open={open}
      label="inbox"
      content={
        <Inbox
          initialTab={0}
          increaseUnreadCountOffset={increaseUnreadCountOffset}
        />
      }
    />
  );
};

export default withApollo(InboxPage);
